/*
 * This code is the intellectual property of Bulb Inc. and other software publishers;
 * it may not be altered, copied or disclosed without prior written approval.
 * Copyright 2015-2020, Bulb Inc.  For more information, please email contact@hellobulb.com.
 */
'use strict';
angular.module('bulbApp.translateModule', ['pascalprecht.translate', 'bulbApp.configModule',
  'bulbApp.authModule'])
.config(['$translateProvider', translateModule])
.factory('asyncLangLoader', () => async ({ key })  => import(`~/resources/translations/locale-${key}.json`))
.run(['$cookies', '$translate', '$rootScope', 'BulbAuthService', run]);

function translateModule($translateProvider) {

  $translateProvider
    // DO LATER : we don't sanitize the data, because we need to be able to embed links and other html code.
    // However, we need a way to escape user provided data appropriately since we can't do it globally here.
    // Perhaps by creating an escapeHTML filter and then running user provided values through it prior to
    // providing the value as a translation interpolation expression.
  .useSanitizeValueStrategy(null)
    .useLoader('asyncLangLoader')
    .registerAvailableLanguageKeys(['de', 'en', 'es', 'fi', 'fr', 'nl', 'no', 'pt', 'sv'], {
      'de*' : 'de',
      'en*' : 'en',
      'es*' : 'es',
      'fi*' : 'fi',
      'fr*' : 'fr',
      'nl*' : 'nl',
      'no*' : 'no',
      'pt*' : 'pt',
      'sv*' : 'sv'
    })
    .fallbackLanguage('en')
    .determinePreferredLanguage();
}

function run($cookies, $translate, $rootScope, BulbAuthService) {

  var language = $cookies.get('language');
  if (!BulbAuthService.currentUser.isAuthenticated() || language) {
    $translate.use(language);
  }

  $rootScope.$watch(function () {
    return BulbAuthService.currentUser;
  }, function() {
    /**
     * If the user is authenticated then we will show the language based on the language they chose for their
     * account settings.
     * If the user is not authenticated then the angular-translate .determinePreferredLanguage() above will chose
     * the language based off the browsers default locale
     */
    if (BulbAuthService.currentUser.isAuthenticated()) {
      $translate.use(BulbAuthService.currentUser.language.toLowerCase());
    } else {
      if (language) {
        $translate.use(language);
      }
    }
  });

  // We don't translate these so that the language names always match for people who speak each language.
  $translate.languages = {
    de : 'Deutsche',
    en : 'English',
    es : 'Español',
    fi : 'Suomi',
    fr : 'Français',
    nl : 'Nederlands',
    no : 'Norsk',
    pt : 'Português',
    sv : 'Svenska'
  };

  $translate.getLanguage = function() {
    return $translate.proposedLanguage() || $translate.use();
  };

  /**
   * Get the list of languages available as list of Object.
   * @returns {{display: *, value: *}[]}
   */
  $translate.getLanguagesList = function () {
    return Array.from(Object.entries(this.languages), ([value, display]) => ({value, display}));
  };

  // When setting locale, check to see if the locale is part of our supported languages enum at Account.java,
  // which is also represented here as $translate.languages above, and if not, use 'en'.
  $translate.localeToString = function() {
    if(Object.keys($translate.languages).includes($translate.use().toString().toLowerCase())){
      return $translate.languages[($translate.proposedLanguage() || $translate.use()).toString().toLowerCase()];
    } else {
      return $translate.use('en');
    }
  };
}
